import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    id: "portfolio",
    class: "portfolio"
};
const _hoisted_2 = { class: "portfolio__header" };
const _hoisted_3 = { class: "portfolio__label" };
const _hoisted_4 = { class: "portfolio__title" };
const _hoisted_5 = { class: "portfolio__cards" };
const _hoisted_6 = { class: "portfolio__card-media" };
const _hoisted_7 = ["src", "alt"];
const _hoisted_8 = { class: "portfolio__card-meta" };
const _hoisted_9 = { class: "portfolio__card-tagline" };
const _hoisted_10 = { class: "portfolio__card-label" };
const _hoisted_11 = { class: "portfolio__footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _directive_reveal = _resolveDirective("reveal");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("header", _hoisted_2, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('portfolio.label')), 1),
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t('portfolio.title')), 1)
        ])), [
            [_directive_reveal]
        ]),
        _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
                return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    key: cat.value,
                    to: _ctx.localizedTo('portfolio-category', { category: cat.value }),
                    class: "portfolio__card"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("img", {
                                src: cat.image,
                                alt: cat.label,
                                loading: "lazy"
                            }, null, 8, _hoisted_7),
                            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "portfolio__card-scrim" }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(cat.tagline), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(cat.label), 1)
                        ])
                    ]),
                    _: 2
                }, 1032, ["to"])), [
                    [_directive_reveal, { delay: cat.delay }]
                ]);
            }), 128))
        ]),
        _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_router_link, {
                to: _ctx.localizedTo('portfolio'),
                class: "portfolio__cta"
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('portfolio.galleryCta')), 1)
                ]),
                _: 1
            }, 8, ["to"])
        ])
    ]));
}
